<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  mode="date"
                  @input="onChangeDateFrom"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.receptionist') }}</div>
                <el-select
                  v-model="searchParams.receptionist"
                  filterable
                  placeholder=""
                  clearable
                >
                  <el-option
                    v-for="item in receptionistOptions"
                    :key="item.id"
                    :label="item.full_name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIdList"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.recode') }}</div>
                <el-select
                  v-model="searchParams.recode"
                  filterable
                  placeholder=""
                  clearable
                >
                  <el-option
                    v-for="item in recodeOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.invoiceNum') }}</div>
                <el-select
                  v-model="searchParams.invoiceCode"
                  filterable
                  placeholder=""
                  clearable
                >
                  <el-option
                    v-for="item in invoiceOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">
                {{ $t('views.report.paymentReport') }}
              </span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />

              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />

          <div v-loading="gridLoading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              dom-layout="scroll"
              :auto-size-cell="true"
              :default-col-def="defaultColDef"
              :is-row-selectable="isRowSelectable"
              :full-width-cell-renderer="fullWidthCellRenderer"
              :suppress-row-transform="true"
              :embed-full-width-rows="true"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Mã đặt phòng</li>
            <li>Số phòng: Số phòng cụ thể</li>
            <li>Tên khách: Tên khách chính của đặt phòng</li>
            <li>Ngày đến: Ngày đến cửa đặt phòng</li>
            <li>Ngày đi: Ngày đi của đặt phòng</li>
            <li>Nguồn: Nguồn của đặt phòng</li>
            <li>
              Giao dịch: Hiển thị tổng tất số tiền cỉa cả các giao dịch phụ của
              đặt phòng
            </li>
            <li>Thu ngân: Hiển thị tài khoản thu ngân thực hiện giao dịch</li>
            <li>
              Thời gian tạo: Thời gian tạo giao dịch. Format: DD/MM/YYYY
              HH:MM:SS
            </li>
            <li>Hình thức thanh toán: ghi rõ hình thức thanh toán</li>
            <li>Tài khoản nhận: số tài khoản nhận thanh toán</li>
            <li>Hiển thị ngày và tổng tiền tất cả các giao dịch trong ngày</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { getAllHotel } from '@/api/hotel.js'
import InfoBtn from '../components/InfoBtn.vue'
import FullWidthCell from './components/FullWidthCell.vue'
import {
  getPaymentReportApi,
  getPaymentReportApiExcel,
  getRecodeApi,
  getInvoiceApi
} from '@/api/report_service/report'
import { ViewInvoiceCellRender } from '@/utils/cellRenders'
import { getAccount } from '@/api/reception/common'
import { dateFormatter } from '@/utils/dataFormatter'
import * as dayjs from 'dayjs'
import { DEFAULT_GRID_ROW_HEIGHT } from '@/constant'
import { downFile } from '@/utils/file-handler'

const getDefaultSearchParams = () => ({
  dateFrom: dayjs().format('YYYY-MM-DD'),
  dateTo: dayjs().format('YYYY-MM-DD'),
  receptionist: null,
  hotelIdList: null
})

const rowSpan = params => {
  if (params.data.rowSpan) {
    return params.data.rowSpan
  }

  return 1
}

const cellStyle = params => ({
  height: `${DEFAULT_GRID_ROW_HEIGHT * params.data.rowSpan}px`,
  'border-left': '1px solid #ccc',
  'border-right': '1px solid #ccc',
  'border-bottom': '1px solid #ccc',
  // 'text-wrap': 'wrap',
  top: 0,
  background: '#fff'
})
const cellStyle1 = params => ({
  'border-left': '1px solid #ccc',
  'border-right': '1px solid #ccc',
  top: 0,
  background: '#fff'
})

export default {
  components: {
    DasButton,
    CalendarSelect,
    InfoBtn,
    // eslint-disable-next-line vue/no-unused-components
    ViewInvoiceCellRender,
    // eslint-disable-next-line vue/no-unused-components
    FullWidthCell
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        // wrapText: true,
        // autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },

      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      hotelOptions: [],
      receptionistOptions: [],
      recodeOptions: [],
      invoiceOptions: [],
      columns: [
        {
          headerName: this.$t('grid.column.recode'),
          field: 'recode',
          tooltipField: 'recode',
          cellRenderer: 'ViewInvoiceCellRender',
          cellRendererParams: params => {
            console.log(params, 'check parne')
            return {
              arrive_date: params.data.arriveDate,
              depart_date: params.data.departDate,
              customer_name: params.data.guestName
            }
          },
          // cellClass: "grid-cell-centered",
          minWidth: 120,
          sortable: false
          // rowSpan: rowSpan,
          // // cellRenderer: params => {
          // //   if (params.value) {
          // //     return `<div>${params.value}</div>`
          // //   }
          // // },
          // cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.roomNo'),
          field: 'roomNum',
          tooltipField: 'roomNum',
          // cellClass: "grid-cell-centered",
          minWidth: 100,
          sortable: false
          // rowSpan: rowSpan,
          // cellRenderer: params => {
          //   if (params.value) {
          //     return `<div>${params.value}</div>`
          //   }
          // },
          // cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.guestName'),
          field: 'guestName',
          tooltipField: 'guestName',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false,
          wrapText: true,
          autoHeight: true
          // rowSpan: rowSpan,
          // cellRenderer: params => {
          //   if (params.value) {
          //     return `<div>${params.value}</div>`
          //   }
          // },
          // cellStyle: cellStyle
        },
        {
          headerName: 'Công ty đại lý du lịch',
          field: 'agent',
          tooltipField: 'agent',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          wrapText: true,
          autoHeight: true,
          sortable: false
          //   rowSpan: rowSpan,
          //   cellRenderer: params => {
          //     if (params.value) {
          //       return `<div>${params.value}</div>`
          //     }
          //   },
          //   cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.arriveDate'),
          field: 'arriveDate',
          cellRendererParams: params => dateFormatter(params.value),
          tooltipValueGetter: params => dateFormatter(params.value),
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          maxWidth: 150,
          sortable: false
          // rowSpan: rowSpan,
          // cellRenderer: params => {
          //   if (params.value) {
          //     return `<div>${params.value}</div>`
          //   }
          // },
          // cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'departDate',
          cellRendererParams: params => dateFormatter(params.value),
          tooltipValueGetter: params => dateFormatter(params.value),
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          maxWidth: 150,
          sortable: false
          // rowSpan: rowSpan,
          // cellRenderer: params => {
          //   if (params.value) {
          //     return `<div>${params.value}</div>`
          //   }
          // },
          // cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.source'),
          field: 'source',
          tooltipField: 'source',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
          // rowSpan: rowSpan,
          // cellRenderer: params => {
          //   if (params.value) {
          //     return `<div>${params.value}</div>`
          //   }
          // },
          // cellStyle: cellStyle
        },
        {
          headerName: this.$t('grid.column.transaction'),
          field: 'transaction',
          tooltipField: 'transaction',
          valueGetter: params => {
            return this.$displayCurrency(params.data.transaction)
          },
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.receptionist'),
          field: 'receptionist',
          tooltipField: 'receptionist',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.cashier'),
          field: 'cashier',
          tooltipField: 'cashier',
          // cellClass: "grid-cell-centered",
          minWidth: 150,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.createdTime'),
          field: 'createDate',
          cellRendererParams: params => dateFormatter(params.value),
          tooltipValueGetter: params => dateFormatter(params.value),
          // cellClass: "grid-cell-centered",
          minWidth: 180,
          maxWidth: 180,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.paymentMethod'),
          field: 'paymentMethod',
          tooltipField: 'paymentMethod',
          // cellClass: "grid-cell-centered",
          minWidth: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.receivedAccount'),
          field: 'recipientAccount',
          tooltipField: 'recipientAccount',
          // cellClass: "grid-cell-centered",
          minWidth: 180,
          sortable: false
        }
      ],
      rows: [],
      gridLoading: false,
      isRowSelectable: node => !node.data.isFullWidthRow
    }
  },
  beforeMount() {
    this.fullWidthCellRenderer = 'FullWidthCell'
  },
  async mounted() {
    await Promise.all([
      this.getHotelOptions(),
      this.getReceiptionistList(),
      this.getRecodeOptions(),
      this.getInvoiceOptions()
    ])
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    async getHotelOptions() {
      await getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },
    async getRecodeOptions() {
      await getRecodeApi().then(res => {
        this.recodeOptions = res.data
      })
    },
    async getInvoiceOptions() {
      await getInvoiceApi().then(res => {
        this.invoiceOptions = res.data
      })
    },

    async getReceiptionistList() {
      getAccount({ department: 'FO' }).then(res => {
        this.receptionistOptions = res.data.map(item => ({
          id: item.account.id,
          username: item.account.username,
          full_name: item.account.full_name
        }))
      })
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmmd) {
      // this.$message('click on item ' + cmmd)
      switch (cmmd) {
        case 'pdf':
          break
        case 'excel':
          this.downloadExcel()
          break
        default:
          this.$message('click on item ' + cmmd)
          break
      }
    },
    async attachData() {
      this.gridLoading = true
      await getPaymentReportApi(this.searchParams)
        .then(res => {
          this.rows = this.convertRowData(res.data)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    async downloadExcel() {
      this.gridLoading = true
      await getPaymentReportApiExcel(this.searchParams)
        .then(res => {
          const date = this.$moment().format('DD-MM-YYYY')
          downFile(res, 'bao_cao_thanh_toan_' + date + '.xlsx')
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.gridLoading = false
        })
    },
    convertRowData(rowData) {
      let newRowData = []

      rowData.forEach(item => {
        const fullWidthRow = {
          date: item.date,
          amountMoney: item.amountMoney,
          isFullWidthRow: true
        }
        newRowData.push(fullWidthRow)
        newRowData = [...newRowData, ...item.infoList]

        // item.infoList.forEach(item1 => {
        //   if (item1.payment_report_child_list?.[0]) {
        //     item1.payment_report_child_list[0] = {
        //       ...item1.payment_report_child_list[0],
        //       recode: item1.recode,
        //       roomNum: item1.roomNum,
        //       agent: item1.agent,
        //       guestName: item1.guestName,
        //       arriveDate: item1.arriveDate,
        //       departDate: item1.departDate,
        //       rowSpan: item1.payment_report_child_list.length,
        //       source: item1.source
        //     }

        //     newRowData = [...newRowData, ...item1.payment_report_child_list]
        //   }
        // })
      })

      return newRowData
    }
  }
}
</script>

<style></style>
